/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./traffic-config.vue?vue&type=template&id=21ceefd2&"
import script from "./traffic-config.vue?vue&type=script&lang=js&"
export * from "./traffic-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports